export const LANDING = '/'
export const PRIVACY_POLICY = '/privacy-policy'
export const LIQUIDITY_INFO = '/liquidity'
